import React, { Fragment, useEffect, useState } from "react";
import { withTranslation } from "react-i18next";

import { Modal } from "reactstrap";
import { ModalBody } from "reactstrap";
import crossIcon from "../../../../../assets/images/cross.svg";
import Text from "components/Text";
import Loader from "components/Loader";
import { Tooltip } from "reactstrap";
import tooltipImg from "../../../../../assets/images/info_black-tooltip.svg";
import Button from "components/Button";
import styles from "../../../PerformanceReview/PerformanceReview.module.scss";

function PublishEvent({
  t,
  isPublishEventModalOpen,
  clostPublishEventModal,
  noOfEmployeeAssigne,
  publishedEventConfirm,
  isDraftPublistEventOpen,
  isLoader,
}) {
  const [pmsConnectTooltip, setPmsConnectTooltip] = useState(false);
  const [publishAsEvent, setPublishAsEvent] = useState("");

  useEffect(() => {
    if (noOfEmployeeAssigne === 0) {
      setPublishAsEvent("allowInvitees");
    } else {
      setPublishAsEvent("inviteesOnly");
    }
  }, [noOfEmployeeAssigne]);

  const preferredOption = [
    {
      title: t("accountOwner.inviteesOnly"),
      msg: t("accountOwner.inviteesOnlyMsg"),
      id: "inviteesOnly",
    },
    {
      title: t("accountOwner.allowInvitees"),
      msg: t("accountOwner.allowInviteesMsg"),
      id: "allowInvitees",
    },
  ];

  const handleEvent = (e) => {
    setPublishAsEvent(e.target.name);
  };

  const handleConfirm = () => {
    if (isDraftPublistEventOpen) {
      publishedEventConfirm(publishAsEvent === "allowInvitees");
    } else {
      publishedEventConfirm(true);
    }
  };

  return (
    <>
      <Modal
        isOpen={isPublishEventModalOpen}
        toggle={() => clostPublishEventModal()}
        className={"modal-dialog-centered modal-lg"}
        modalClassName="custom-modal"
      >
        <span className="close-btn" onClick={() => clostPublishEventModal()}>
          <img src={crossIcon} alt="close" />
        </span>

        <ModalBody>
          {isLoader && <Loader />}
          <Text
            size="25px"
            marginBottom="10px"
            weight="500"
            align="center"
            color="#111b45"
          >
            <span className="modal-title-25 text-center">
              {t("scheduler.publishEvent")}
            </span>
          </Text>
          {!isDraftPublistEventOpen ? (
            <Fragment>
              <Text size="16px" weight="300" color="#535b5f" align="center">
                {t("scheduler.publishTheEventDesc")}
              </Text>
              <Text
                size="16px"
                marginBottom="40px"
                weight="300"
                color="#535b5f"
                align="center"
              >
                {t("scheduler.areYouSureYouWantToPublishTheEvent")}
              </Text>
            </Fragment>
          ) : (
            <Fragment>
              <Text size="16px" weight="300" color="#535b5f" align="center">
                {t("scheduler.isDraftPublishTitle")}
              </Text>
              <div className="ch-radio d-flex flex-column align-items-start">
                {preferredOption?.map((val, index) => (
                  <Fragment key={index}>
                    <label className="mr-5">
                      <input
                        type="radio"
                        name={val.id}
                        checked={val.id === publishAsEvent}
                        onChange={handleEvent}
                        disabled={noOfEmployeeAssigne === 0}
                      />
                      <span>
                        {val.title}
                        <img
                          src={tooltipImg}
                          id={val.id}
                          alt="tooltip"
                          className="ml-2"
                          onMouseOver={() => setPmsConnectTooltip(val.id)}
                          onMouseLeave={() => setPmsConnectTooltip(null)}
                        />
                      </span>
                    </label>
                    <Tooltip
                      className="new-item-card-catalogue-tooltip"
                      isOpen={pmsConnectTooltip === val.id}
                      placement="top"
                      target={val.id}
                    >
                      {val.msg}
                    </Tooltip>
                  </Fragment>
                ))}
              </div>
            </Fragment>
          )}

          <div
            className={`text-center d-flex justify-content-center mt-4 ${styles.home_btn_wrapper}`}
          >
            <Button
              padding="0 83px"
              onClick={handleConfirm}
              title={t("scheduler.publishEvent")}
            >
              {t("scheduler.publish")}
            </Button>
            <Button
              borderedSecondaryNew
              padding="0 73px"
              onClick={() => clostPublishEventModal()}
              title={t("cancel")}
            >
              <span> {t("cancel")}</span>
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
}

export default withTranslation()(PublishEvent);
